import { useCallback, useEffect, useMemo } from 'react';
import { debounce } from 'throttle-debounce';

import { useElementsRefContext } from '@/app/shared/context/ElementsRefContext';

import { useListingLayoutFiltersHeightSelector } from '@/packages/redux-state/store/slices/listingLayout';

const THROTTLE_DELAY = 100;

export function useCalculateMapSizes(): void {
  const filtersHeight = useListingLayoutFiltersHeightSelector();

  const { mapContainerRef } = useElementsRefContext();

  const onWindowResize = useCallback(() => {
    const mapContainer = mapContainerRef.current;

    if (!mapContainer) {
      return;
    }

    mapContainer.style.setProperty('--map-top-offset', `${filtersHeight}px`);
  }, [filtersHeight, mapContainerRef]);

  const onWindowResizeThrottled = useMemo(() => debounce(THROTTLE_DELAY, onWindowResize), [onWindowResize]);

  useEffect(() => {
    onWindowResize();
  }, [onWindowResize]);

  useEffect(() => {
    window.addEventListener('resize', onWindowResizeThrottled);

    return (): void => {
      window.removeEventListener('resize', onWindowResizeThrottled);
    };
  }, [onWindowResize, onWindowResizeThrottled]);
}
